module.exports = __webpack_public_path__ + "img/nopaper-icon.3314b088.png";